<template>
  <div>
	<div class="cgqBox">
		<div class="cgqBoxTil">
			{{list.data.menuTitle}}
		</div>
		<div class="cgqBoxCen">
			<div v-for="(item,index) in list.data.desc" :key="index">{{item.text}}</div>
		</div>
		<div class="cgqBoxSp">
			<img :src="list.data.cover" />
			<!-- <video></video> -->
		</div>
	</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
	props:{
		list:{
			typeof:Object,
			default:{}
		}
	},
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.cgqBox{
	width: 1200px;
	margin: 0 auto;
	padding-bottom: 150px;
	.cgqBoxTil{
		font-size: 45px;
		
		font-weight: bold;
		color: #000000;
		margin-bottom: 40px;
	}
	.cgqBoxCen{
		font-size: 18px;
		
		font-weight: 300;
		color: #000000;
		margin-bottom: 40px;
		>div{
			white-space: pre-line;
		}
	}
	.cgqBoxSp{
		width: 100%;
		height: 600px;
		margin-bottom: 38px;
		img{
			width: 100%;
			height: 100%;
		}
		video{
			width: 100%;
			height: 100%;
		}
	}
	.cgqBoxXiao{
		display: flex;
		overflow-x: auto;
		.cgqBoxFor:not(:last-child){
			margin-right: 40px;
		}
		.cgqBoxFor{
			width: 300px;
			
			.cgqBoxForImg{
				width: 70px;
				height: 70px;
				margin-bottom: 40px;
				img{
					width: 70px;
					height: 70px;
					object-fit: cover;
				}
			}
			.cgqBoxForName{
				font-size: 26px;
				
				font-weight: 400;
				color: #000000;
				margin-bottom: 32px;
			}
			.cgqBoxForCen{
				font-size: 18px;
				
				font-weight: 300;
				color: #000000;
			}
		}
	}
}

	@media screen and (max-width:1200px) {
		.cgqBox{
			width: 100% !important;
			padding:0 30px 30px !important;
			box-sizing: border-box;
			.cgqBoxTil{
				font-size: 24px !important;
				margin-bottom: 20px !important;
			}
			.cgqBoxCen{
				font-size: 14px !important;
				margin-bottom: 20px !important;
			}
			.cgqBoxSp{
				height: auto !important;
				margin-bottom: 0px !important;
			}
		}
	}
</style>
